import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { fetchSpecificListing } from "../../Features/Market/Market_Archive";
import { ethers } from "ethers";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useWallet } from "../../../contexts/WalletContext";
import { useAuth } from "../../../contexts/AuthContext";
import { MARKET_ABI } from "../../../contracts/contracts";
import "./UploadArchive.scss";

const REGULAR_PAYMENT_LINK = "https://pay.ziina.com/funooni/tedKYzq6h";
const MARKET_ADDRESS = "0x4894B177ac9166A2D89f1F920E7EC15a4A015a14";

const UploadArchive = () => {
  const navigate = useNavigate();
  const {
    ethAddress: walletAddress,
    connectWallet,
    provider,
    isConnecting,
  } = useWallet();
  const { ethAddress: authEthAddress } = useAuth();
  const activeAddress = walletAddress || authEthAddress;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isBuying, setIsBuying] = useState(false);
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [ethBalance, setEthBalance] = useState(null);

  useEffect(() => {
    const loadListingData = async () => {
      setLoading(true);
      setError(null);
      try {
        const listingData = await fetchSpecificListing("2");
        if (listingData) setData(listingData);
        else setError("Listing ID 2 not found or inactive.");
      } catch (err) {
        console.error("Failed to load listing:", err);
        setError("Failed to fetch data from the blockchain/subgraph.");
      } finally {
        setLoading(false);
      }
    };
    loadListingData();
  }, []);

  useEffect(() => {
    if (!activeAddress || !provider) return;

    const web3Provider = new ethers.BrowserProvider(
      provider || window.ethereum
    );

    const fetchBalance = async () => {
      try {
        const balanceInWei = await web3Provider.getBalance(activeAddress);
        setEthBalance(ethers.formatEther(balanceInWei));
      } catch (err) {
        console.error("Failed to fetch balance:", err);
        setEthBalance("Error");
      }
    };

    fetchBalance();

    const interval = setInterval(fetchBalance, 5000);
    return () => clearInterval(interval);
  }, [activeAddress, provider]);

  const handleConnectWallet = async () => {
    await connectWallet();
    setShowWalletModal(false);

    if (walletAddress || authEthAddress) {
      try {
        const web3Provider = new ethers.BrowserProvider(
          provider || window.ethereum
        );
        const balanceInWei = await web3Provider.getBalance(
          walletAddress || authEthAddress
        );
        setEthBalance(ethers.formatEther(balanceInWei));
      } catch (err) {
        console.error("Failed to fetch balance:", err);
        setEthBalance("Error");
      }
    }
  };

  const handleBuyNFT = async () => {
    if (!data) return;

    const quantity = 1;

    if (!activeAddress) {
      toast.warn("⚠️ Please connect your wallet first!");
      setShowWalletModal(true);
      return;
    }

    setIsBuying(true);
    try {
      const web3Provider = new ethers.BrowserProvider(
        provider || window.ethereum
      );
      const signer = await web3Provider.getSigner();
      const marketContract = new ethers.Contract(
        MARKET_ADDRESS,
        MARKET_ABI,
        signer
      );

      const pricePerTokenEthString = data.priceEth
        .toString()
        .replace(" ETH", "")
        .trim();
      const pricePerTokenWei = ethers.parseEther(pricePerTokenEthString);

      const quantityBigInt = ethers.toBigInt(quantity);
      const totalPriceWei = pricePerTokenWei * quantityBigInt;

      const balance = await web3Provider.getBalance(activeAddress);
      if (balance < totalPriceWei) {
        toast.error("❌ Not enough ETH to complete the purchase.");
        setIsBuying(false);
        return;
      }

      toast.info(
        `🔔 Confirm transaction to buy ${quantity} Access Keys for ${data.priceEth} each`
      );

      const tx = await marketContract.buy(data.id, quantity, {
        value: totalPriceWei,
      });
      await tx.wait();

      toast.success(
        "✅ Purchase successful! Access Keys should appear in your wallet."
      );

      const updatedBalance = await web3Provider.getBalance(activeAddress);
      setEthBalance(ethers.formatEther(updatedBalance));
    } catch (err) {
      console.error("NFT Purchase Failed:", err);
      let errorMessage = "❌ Puarchase failed. Please check console.";

      if (err.code === 4001 || err.message.includes("user rejected")) {
        errorMessage = "❌ Transaction rejected by user.";
      } else if (err.data && err.data.message) {
        errorMessage = `❌ Purchase failed: ${err.data.message}`;
      } else if (err.message.includes("insufficient payment")) {
        errorMessage =
          "❌ Purchase failed: Insufficient ETH sent to cover total price and fees.";
      }

      toast.error(errorMessage);
    } finally {
      setIsBuying(false);
    }
  };

  const handleArchiveVisit = () => {
    navigate("/archive-access");
  };

  if (loading)
    return (
      <section className="archive-block loading-state">
        <p>Loading Access Key details...</p>
      </section>
    );

  if (error || !data)
    return (
      <section className="archive-block error-state">
        <p>Error: {error || "No data available."}</p>
      </section>
    );
const archiveImage = data.image || data.file;
  return (
    <>
      <section className="archive-block">
        <ToastContainer position="top-right" autoClose={5000} />
        <div className="topImage">
          <div className="div-archive-image">
            <div
              className="archive-image"
              style={{ backgroundImage: `url(${archiveImage})` }}
            ></div>
            <div className="dots-pattern2"></div>
          </div>
          <div className="archive-content">
            <div className="archive-header">
              <h2>{data.title}</h2>
              <div className="price2">
                <span>{data.priceEth}</span>
                <p>≈ {data.priceUsd} USD</p>
              </div>
            </div>
            <div className="dotted-line"></div>
            <p className="text-content">{data.content}</p>
          </div>
        </div>
        <div className="bottom-section2">
          <button className="footer-line" onClick={handleArchiveVisit}>
            Visit Collection Archive
          </button>
          <div className="bottom-controls">
            <div className="buttons-group">
              <button
                className="buttons3-button1"
                onClick={handleBuyNFT}
                disabled={isBuying || data.quantity === 0}
              >
                {isBuying
                  ? "Processing..."
                  : data.quantity === 0
                  ? "Sold Out"
                  : "Buy Access Key"}
              </button>
              <a
                href={REGULAR_PAYMENT_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                <button>Purchase Access (Card)</button>
              </a>
            </div>
          </div>
        </div>
      </section>

      {showWalletModal &&
        ReactDOM.createPortal(
          <div
            className="modal-overlay-global"
            onClick={() => setShowWalletModal(false)}
          >
            <div
              className="modal-box-global"
              onClick={(e) => e.stopPropagation()}
            >
              <h3>Connect Your Wallet</h3>
              <p>You need to connect your wallet to continue.</p>
              <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
                <button onClick={handleConnectWallet} disabled={isConnecting}>
                  {isConnecting ? "Connecting..." : "Connect Wallet"}
                </button>
                <button
                  onClick={() => setShowWalletModal(false)}
                  disabled={isConnecting}
                >
                  Close
                </button>
              </div>
            </div>
          </div>,
          document.getElementById("modal-root")
        )}
    </>
  );
};

export default UploadArchive;
